<template>
    <p>Are you sure you want to delete this Steward?</p>
    <br />
    <p>[ {{ item.name }} ]</p>
</template>

<script setup lang="ts">
import { type ISteward } from '@app/land-hold/steward/models/Steward.ts';
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { useStewardRepository } from '@app/land-hold/steward/repositories/useStewardRepository';

const props = defineProps({
    item: {
        type: Object as PropType<ISteward>,
        required: true,
    },
});

const destroy = useStewardRepository().command.destroy(props.item.id);
useInjectSubmitForm(destroy.execute);
</script>
